import { Box, Button, Card, CardContent } from '@mui/material'
import { useContext } from 'react'
import { OnboardingContext } from '../context/onboarding/OnboardingContext'
import { HTMLText } from '@wolfdanepug/common-react'
import { OnboardingState } from '../types'

export default function Actions() {
	const { useOnboardingState, skipStep } = useContext(OnboardingContext)
	const { canStepForward, actionsText, canSkipStep }: Partial<OnboardingState> =
		useOnboardingState()

	return (
		<Box sx={styles.actions}>
			{actionsText && <HTMLText text={actionsText} sx={{ fontSize: '1.2rem' }} />}
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'row',
					justifyContent: 'center'
				}}
			>
				<Button variant="contained" disabled={!canStepForward} type="submit" size="large">
					Continue
				</Button>
				{canSkipStep && (
					<Button variant="text" fullWidth size="large" onClick={skipStep}>
						Skip
					</Button>
				)}
			</Box>
		</Box>
	)
}

const styles = {
	actions: {
		// position: 'fixed',
		// bottom: 0,
		// left: 0,
		width: '100%',
		backgroundColor: '#fff',
		p: 4,
		textAlign: 'center'
		// boxShadow:
		// 	'0px -2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)' // '
	},
	actionsContent: {
		display: 'inline-flex'
	}
}
